export { SegmentedControl } from "@mantine/core";
export type { SegmentedControlProps } from "@mantine/core";
export { getSegmentedControlOverrides } from "./SegmentedControl.styled";
